import { render, staticRenderFns } from "./AuthCallbackView.vue?vue&type=template&id=a533267e&scoped=true"
import script from "./AuthCallbackView.vue?vue&type=script&lang=js"
export * from "./AuthCallbackView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a533267e",
  null
  
)

export default component.exports